<template>
	<transition 
			appear
			:appear-active-class="$_slsPrdCrdLyt_stylePageLayoutAnimation()">
		<v-row	class="customVRow" 
				align="start">
			<v-col>
				<v-row>
					<v-col cols="12" sm="6" md="4" lg="3" xl="2">
						<v-card class="customVCard"
								:color="$_slsPrdCrdLyt_styleCardColor"
								:dark="$_slsPrdCrdLyt_styleCardDark"
								:elevation="$_slsPrdCrdLyt_styleCardElevation"
								:flat="$_slsPrdCrdLyt_styleCardFlat"
								:hover="$_slsPrdCrdLyt_styleCardHover"
								:light="$_slsPrdCrdLyt_styleCardLight"
								:outlined="$_slsPrdCrdLyt_styleCardOutlined"
								:raised="$_slsPrdCrdLyt_styleCardRaised"
								:tile="$_slsPrdCrdLyt_styleCardTile">
							<template v-if="$_slsPrdCrdLyt_langProductCardProductCodeTitle">
								<v-card-title>
									<v-row dense>
										<v-col>
											<span	class="title"
													v-html="$_slsPrdCrdLyt_langProductCardProductCodeTitle" />
										</v-col>
									</v-row>
								</v-card-title>
							</template>
							<template v-if="$_slsPrdCrdLyt_styleProductCardProductCodeImageUrl">
								<v-row>
									<v-col>
										<v-img	class="customVImg"
												cover 
												:src="$_slsPrdCrdLyt_styleProductCardProductCodeImageUrl" />
									</v-col>
								</v-row>
							</template>
							<template v-if="$_slsPrdCrdLyt_langProductCardProductCodeSubTitle">
								<v-card-title>
									<v-row dense>
										<v-col>
											<span	class="body-2"
													v-html="$_slsPrdCrdLyt_langProductCardProductCodeSubTitle" />
										</v-col>
									</v-row>
								</v-card-title>
							</template>
							<template v-if="$_slsPrdCrdLyt_langProductCardProductCodeText">
								<v-card-text>
									<v-row dense>
										<v-col>
											<span v-html="$_slsPrdCrdLyt_langProductCardProductCodeText" />
										</v-col>
									</v-row>
								</v-card-text>
							</template>
							<v-card-actions>
								<v-row dense>
									<v-col>
										<v-dialog
												persistent
												width="350px"
												v-model="dialogEnterProductCode_">
											<template v-slot:activator="{ on }">
												<v-btn	class="customVBtn"

														block

														:color="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonColor"
														:dark="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonDark"
														:depressed="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonDepressed"
														:elevation="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonElevation"
														:large="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonLarge"
														:light="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonLight"
														:outlined="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonOutlined"
														:rounded="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonRounded"
														:small="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonSmall"
														:text="$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonFlat"
														
														@click="dialogEnterProductCode_ = !dialogEnterProductCode_"

														v-text="$_slsPrdCrdLyt_langProductCardEnterProductCode" 
														
														v-on="on"/>
											</template>

											<v-card>
												<v-card-title>
													Product Code
												</v-card-title>

												<v-card-text>
													<template v-if="errorMessageEnterProductCode_">
														<v-row dense>
															<v-col>
																<span style="color: red" v-text="errorMessageEnterProductCode_" />
															</v-col>
														</v-row>
													</template>
													<v-row dense align="end">
														<v-col>
															<v-text-field hide-details />
														</v-col>
														<v-col cols="auto">
															<v-btn	class="customVBtn"
																	icon>
																<v-icon>
																	perm_device_information
																</v-icon>
															</v-btn>
														</v-col>
													</v-row>													
												</v-card-text>

												<v-card-actions>
													<v-row dense justify="center">
														<v-col cols="auto">
															<v-btn	class="customVBtn"
																	@click="dialogEnterProductCode_ = !dialogEnterProductCode_">
																Enter
															</v-btn>
														</v-col>
													</v-row>
												</v-card-actions>
											</v-card>
										</v-dialog>
									</v-col>
								</v-row>
							</v-card-actions>
						</v-card>
					</v-col>
					<template v-for="(productVals, productKey) in sortObject($_slsPrdCrdLyt_salesProducts, 'order')">
						<v-col	:key="productKey"
								cols="12" sm="6" md="4" lg="3" xl="2">
							<v-card class="customVCard"
									:color="$_slsPrdCrdLyt_checkAmount(productKey) ? 'error' : $_slsPrdCrdLyt_styleCardColor"
									:dark="$_slsPrdCrdLyt_styleCardDark"
									:elevation="$_slsPrdCrdLyt_styleCardElevation"
									:flat="$_slsPrdCrdLyt_styleCardFlat"
									:hover="$_slsPrdCrdLyt_styleCardHover"
									:light="$_slsPrdCrdLyt_styleCardLight"
									:outlined="$_slsPrdCrdLyt_styleCardOutlined"
									:raised="$_slsPrdCrdLyt_styleCardRaised"
									:tile="$_slsPrdCrdLyt_styleCardTile">
								<template v-if="productVals.image">
									<v-row>
										<v-col>
											<v-img	class="customVImg"
													cover 
													:src="$_slsPrdCrdLyt_styleProductImageUrl(productVals)"
													@click="$_slsPrdCrdLyt_addProduct(productKey)" />
										</v-col>
									</v-row>
								</template>
								<template v-if="productVals.title">
									<v-card-title>
										<v-row dense>
											<v-col>
												<span	class="title"
														v-html="$_slsPrdCrdLyt_langProductTitle(productVals)" />
											</v-col>
										</v-row>
									</v-card-title>
								</template>
								<template v-if="productVals.chips">
									<v-card-actions>
										<v-row dense>
											<template v-for="(chipVals, chipKey) in sortObject(productVals.chips)">
												<v-col	:key="chipKey"
														cols="auto">
													<v-chip pill
															:color="$_slsPrdCrdLyt_styleChipColor"
															:dark="$_slsPrdCrdLyt_styleChipDark"
															:label="$_slsPrdCrdLyt_styleChipLabel"
															:light="$_slsPrdCrdLyt_styleChipLight"
															:outlined="$_slsPrdCrdLyt_styleChipOutlined"
															:small="$_slsPrdCrdLyt_styleChipSmall"
															:text-color="$_slsPrdCrdLyt_styleChipTextColor">
														<v-avatar
																left
																:color="$_slsPrdCrdLyt_getChanceColor(chipKey)">
															#
														</v-avatar>
														<span v-text="chipKey" />
													</v-chip>
												</v-col>
											</template>
										</v-row>
									</v-card-actions>
								</template>
								<template v-if="productVals.text">
									<v-card-text>
										<v-row dense>
											<v-col>
												<span v-html="$_slsPrdCrdLyt_langProductText(productVals)" />
											</v-col>
										</v-row>
									</v-card-text>
								</template>
								<template v-if="isObject(productVals.actionButtons)">
									<v-card-actions class="cardActions_">
										<v-row dense>
											<template v-for="(actionButtonVals, actionButtonKey) in sortObject(productVals.actionButtons, 'order')">
												<v-col :key="actionButtonKey" cols="auto">
													<v-btn	class="customVBtn"
															:block="$_slsPrdCrdLyt_styleActionButtonBlock"
															:color="$_slsPrdCrdLyt_styleActionButtonColor"
															:dark="$_slsPrdCrdLyt_styleActionButtonDark"
															:depressed="$_slsPrdCrdLyt_styleActionButtonDepressed"
															:elevation="$_slsPrdCrdLyt_styleActionButtonElevation"
															:large="$_slsPrdCrdLyt_styleActionButtonLarge"
															:light="$_slsPrdCrdLyt_styleActionButtonLight"
															:outlined="$_slsPrdCrdLyt_styleActionButtonOutlined"
															:rounded="$_slsPrdCrdLyt_styleActionButtonRounded"
															:small="$_slsPrdCrdLyt_styleActionButtonSmall"
															:text="$_slsPrdCrdLyt_styleActionButtonFlat"
															@click="openLink(actionButtonVals.link)"
															v-text="$_slsPrdCrdLyt_langActionButtonTitle(actionButtonVals)" />
												</v-col>
											</template>
										</v-row>
									</v-card-actions>
								</template>
								<template v-if="!isFalse(productVals.serialNumbers)">
									<v-card-actions>
										<v-row dense>
											<v-col>
												<v-btn	class="customVBtn"

														block

														:color="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonColor"
														:dark="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonDark"
														:depressed="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonDepressed"
														:elevation="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonElevation"
														:large="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonLarge"
														:light="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonLight"
														:outlined="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonOutlined"
														:rounded="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonRounded"
														:small="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonSmall"
														:text="$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonFlat"
														@click="$_slsPrdCrdLyt_toggleEnterSerialNumber(productKey)"
														v-text="$_slsPrdCrdLyt_langProductCardEnterSerialNumber" />
											</v-col>
										</v-row>
									</v-card-actions>
								</template>
								<template v-else>
									<v-card-actions>
										<v-row dense align="center">
											<v-col>
												<v-text-field 
														outlined hide-details 
														v-model="$store.state.user.sales[$_slsPrdCrdLyt_paramsMerchantId].addedProduct[productKey].amount"/>
											</v-col>
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														icon
														outlined
														@click="$_slsPrdCrdLyt_addProduct(productKey)">
													<v-icon>exposure_plus_1</v-icon>
												</v-btn>
											</v-col>
											<v-col cols="auto">
												<v-btn	class="customVBtn"
														outlined
														icon
														@click="$_slsPrdCrdLyt_reduceProduct(productKey)">
													<v-icon>exposure_neg_1</v-icon>
												</v-btn>
											</v-col>
										</v-row>
									</v-card-actions>
								</template>
							</v-card>
						</v-col>
					</template>
				</v-row>
				<v-row class="row_">
					<v-col class="center">
						<v-btn	class="customVBtn btn_"

								absolute fixed bottom x-large

								:block="$_slsPrdCrdLyt_styleProductCardInputButtonBlock"
								:color="$_slsPrdCrdLyt_styleProductCardInputButtonColor"
								:dark="$_slsPrdCrdLyt_styleProductCardInputButtonDark"
								:depressed="$_slsPrdCrdLyt_styleProductCardInputButtonDepressed"
								:elevation="$_slsPrdCrdLyt_styleProductCardInputButtonElevation"
								:light="$_slsPrdCrdLyt_styleProductCardInputButtonLight"
								:outlined="$_slsPrdCrdLyt_styleProductCardInputButtonOutlined"
								:rounded="$_slsPrdCrdLyt_styleProductCardInputButtonRounded"
								:text="$_slsPrdCrdLyt_styleProductCardInputButtonFlat"
								@click="$_slsPrdCrdLyt_openInput()"
								v-text="'Input'" />
					</v-col>
				</v-row>
				<v-dialog
						persistent
						width="350px"
						v-model="dialogEnterSerialNumber_">
					<v-card>
						<v-card-title>
							Serial Number
						</v-card-title>

						<v-card-text>
							<template v-if="errorMessageEnterSerialNumber_">
								<v-row dense>
									<v-col>
										<span style="color: red" v-text="errorMessageEnterSerialNumber_" />
									</v-col>
								</v-row>
							</template>
							<v-row dense align="end">
								<v-col>
									<v-text-field hide-details v-model="serialNumber_.number" />
								</v-col>
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											icon>
										<v-icon>
											perm_device_information
										</v-icon>
									</v-btn>
								</v-col>
							</v-row>													
						</v-card-text>

						<v-card-actions>
							<v-row dense justify="center">
								<v-col cols="auto">
									<v-btn	class="customVBtn"
											@click="$_slsPrdCrdLyt_enterSerialNumber()">
										Enter
									</v-btn>
									<v-btn	class="customVBtn"
											@click="dialogEnterSerialNumber_ = !dialogEnterSerialNumber_">
										Cancel
									</v-btn>
								</v-col>
							</v-row>
						</v-card-actions>
					</v-card>
				</v-dialog>
			</v-col>
		</v-row>
	</transition>
</template>

<script>
	export default {
		name: 'SalesProductCardLayout',
		props: {
			merchants: Object,

			contents: Object,
			inits: Object
		},
		data() {
			return {
				amount_: {
					dummyProduct1: 0,
					dummyProduct2: 0,
					dummyProduct3: 0
				},

				colors_: {},

				serialNumbers_: {
				//	productKey: {
				//		
				//	}
				},

				dialogEnterProductCode_: false,
				dialogEnterSerialNumber_: false,

				productCode_: {
					key: null,
					code: null
				},

				serialNumber_: {
					key: null,
					number: null
				},

				errorMessageEnterProductCode_: 'No Error',
				errorMessageEnterSerialNumber_: 'No Error'
			}
		},
		computed: {
			// params
			$_slsPrdCrdLyt_params() {
				const self_ = this;
				const route_ = self_.$route
				return route_.params
			},
			$_slsPrdCrdLyt_paramsMerchantId() {
				const self_ = this;
				const params_ = self_.$_slsPrdCrdLyt_params;
				if(self_.isFalse(params_)) { return null }
				return params_.merchantId
			},
			// sales
			$_slsPrdCrdLyt_salesMerchant() {
				const self_ = this;
				return self_.merchants[self_.$_slsPrdCrdLyt_paramsMerchantId]
			},
			$_slsPrdCrdLyt_salesProducts() {
				const self_ = this;
				const merchant_ = self_.$_slsPrdCrdLyt_salesMerchant;
				if(self_.isEmpty(merchant_)) { return null }
				return merchant_.products
			},
			// state
			$_slsPrdCrdLyt_stateUserSales() {
				const self_ = this;
				const sales_ = self_.getUserState('sales')
				return sales_[self_.$_slsPrdCrdLyt_paramsMerchantId]
			},
			$_slsPrdCrdLyt_stateUserSalesOpenedProduct() {
				const self_ = this;
				const sales_ = self_.$_slsPrdCrdLyt_stateUserSales;
				if(self_.isEmpty(sales_)) { return null }
				return sales_.openedProduct
			},
			// lang 
			$_slsPrdCrdLyt_langProductCardProductCodeTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'productCardProductCodeTitle')
				return self_.getLangsVal(lang_)
			},
			$_slsPrdCrdLyt_langProductCardProductCodeSubTitle() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'productCardProductCodeSubTitle')
				return self_.getLangsVal(lang_)
			},
			$_slsPrdCrdLyt_langProductCardProductCodeText() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'productCardProductCodeText')
				return self_.getLangsVal(lang_)
			},
			$_slsPrdCrdLyt_langProductCardEnterProductCode() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'productCardEnterProductCode')
				return self_.getLangsVal(lang_)
			},
			$_slsPrdCrdLyt_langProductCardEnterSerialNumber() {
				const self_ = this;
				const lang_ = self_.getInitsLangVal(self_.inits, 'productCardEnterSerialNumber')
				return self_.getLangsVal(lang_)
			},
			// (content)
			$_slsPrdCrdLyt_langProductTitle() {
				const self_ = this;
				return productVals => {
					const title_ = productVals.title;
					if(self_.isFalse(title_)) { return null }
					return self_.getLangsVal(title_)
				}
			},
			$_slsPrdCrdLyt_langProductSubTitle() {
				const self_ = this;
				return productVals => {
					const subTitle_ = productVals.subTitle;
					if(self_.isFalse(subTitle_)) { return null }
					return self_.getLangsVal(subTitle_)
				}
			},
			$_slsPrdCrdLyt_langProductText() {
				const self_ = this;
				return productVals => {
					const text_ = productVals.text;
					if(self_.isFalse(text_)) { return null }
					return self_.getLangsVal(text_)
				}
			},
			// (content - action button)
			$_slsPrdCrdLyt_langActionButtonTitle() {
				const self_ = this;
				return actionButtonVals => {
					const actionButtonVal_ = actionButtonVals.title;
					if(self_.isFalse(actionButtonVal_)) { return null }
					return self_.getLangsVal(actionButtonVal_)
				}
			},
			// style
			$_slsPrdCrdLyt_stylePageLayout() {
				const self_ = this;
				return () => {
					if(self_.isEmpty(self_.inits)) { return null }
					return self_.getInitsStyleVal(self_.inits, 'pageLayout')
				}
			},
			$_slsPrdCrdLyt_stylePageLayoutAnimation() {
				const self_ = this;
				return () => {
					const layout_ = self_.$_slsPrdCrdLyt_stylePageLayout()
					if(self_.isFalse(layout_)) { return null }
					return self_.getStylesVal(layout_.animation)
				}
			},
			$_slsPrdCrdLyt_styleProductCardProductCodeImage() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'productCardProductCodeImage')
			},
			$_slsPrdCrdLyt_styleProductCardProductCodeImageUrl() {
				const self_ = this;
				const image_ = self_.$_slsPrdCrdLyt_styleProductCardProductCodeImage;
				if(self_.isFalse(image_)) { return null }
				return self_.getStylesVal(image_.url)
			},
			$_slsPrdCrdLyt_styleCard() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'productCardCard')
			},
			$_slsPrdCrdLyt_styleCardColor() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.color)
			},
			$_slsPrdCrdLyt_styleCardDark() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.dark)
			},
			$_slsPrdCrdLyt_styleCardElevation() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.elevation)
			},
			$_slsPrdCrdLyt_styleCardFlat() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.flat)
			},
			$_slsPrdCrdLyt_styleCardHover() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.hover)
			},
			$_slsPrdCrdLyt_styleCardLight() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.light)
			},
			$_slsPrdCrdLyt_styleCardOutlined() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.outlined)
			},
			$_slsPrdCrdLyt_styleCardRaised() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.raised)
			},
			$_slsPrdCrdLyt_styleCardTile() {
				const self_ = this;
				const card_ = self_.$_slsPrdCrdLyt_styleCard;
				if(self_.isFalse(card_)) { return null }
				return self_.getStylesVal(card_.tile)
			},
			$_slsPrdCrdLyt_styleActionButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'productCardActionButton')
			},
			$_slsPrdCrdLyt_styleActionButtonBlock() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_slsPrdCrdLyt_styleActionButtonColor() {
				const self_ = this;
				const button_ =self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_slsPrdCrdLyt_styleActionButtonDark() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_slsPrdCrdLyt_styleActionButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_slsPrdCrdLyt_styleActionButtonElevation() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_slsPrdCrdLyt_styleActionButtonFlat() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_slsPrdCrdLyt_styleActionButtonLarge() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_slsPrdCrdLyt_styleActionButtonLight() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_slsPrdCrdLyt_styleActionButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_slsPrdCrdLyt_styleActionButtonRounded() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_slsPrdCrdLyt_styleActionButtonSmall() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleActionButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_slsPrdCrdLyt_styleChip() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'productCardChip')
			},
			$_slsPrdCrdLyt_styleChipColor() {
				const self_ = this;
				const chip_ =self_.$_slsPrdCrdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.color)
			},
			$_slsPrdCrdLyt_styleChipDark() {
				const self_ = this;
				const chip_ = self_.$_slsPrdCrdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.dark)
			},
			$_slsPrdCrdLyt_styleChipLabel() {
				const self_ = this;
				const chip_ = self_.$_slsPrdCrdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.label)
			},
			$_slsPrdCrdLyt_styleChipLight() {
				const self_ = this;
				const chip_ = self_.$_slsPrdCrdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.light)
			},
			$_slsPrdCrdLyt_styleChipOutlined() {
				const self_ = this;
				const chip_ = self_.$_slsPrdCrdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.outlined)
			},
			$_slsPrdCrdLyt_styleChipSmall() {
				const self_ = this;
				const chip_ = self_.$_slsPrdCrdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.small)
			},
			$_slsPrdCrdLyt_styleChipTextColor() {
				const self_ = this;
				const chip_ = self_.$_slsPrdCrdLyt_styleChip;
				if(self_.isFalse(chip_)) { return null }
				return self_.getStylesVal(chip_.textColor)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'productCardEnterProductCodeButton')
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonBlock() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonColor() {
				const self_ = this;
				const button_ =self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonDark() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonElevation() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonFlat() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonLarge() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonLight() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonRounded() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_slsPrdCrdLyt_styleProductCardEnterProductCodeButtonSmall() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterProductCodeButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'productCardEnterSerialNumberButton')
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonBlock() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonColor() {
				const self_ = this;
				const button_ =self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonDark() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonElevation() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonFlat() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonLarge() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonLight() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonRounded() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButtonSmall() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardEnterSerialNumberButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			$_slsPrdCrdLyt_styleProductCardInputButton() {
				const self_ = this;
				return self_.getInitsStyleVal(self_.inits, 'productCardInputButton')
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonBlock() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.block)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonColor() {
				const self_ = this;
				const button_ =self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.color)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonDark() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.dark)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonDepressed() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.depressed)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonElevation() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.elevation)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonFlat() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.flat)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonLarge() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.large)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonLight() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.light)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonOutlined() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.outlined)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonRounded() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.rounded)
			},
			$_slsPrdCrdLyt_styleProductCardInputButtonSmall() {
				const self_ = this;
				const button_ = self_.$_slsPrdCrdLyt_styleProductCardInputButton;
				if(self_.isFalse(button_)) { return null }
				return self_.getStylesVal(button_.small)
			},
			// (product)
			$_slsPrdCrdLyt_styleProductImage() {
				return productVals => {
					return productVals.image
				}
			},
			$_slsPrdCrdLyt_styleProductImageUrl() {
				const self_ = this;
				return productVals => {
					const image_ = self_.$_slsPrdCrdLyt_styleProductImage(productVals)
					if(self_.isEmpty(image_)) { return null }
					return self_.getStylesVal(image_.url)
				}
			}
		},
		created() {
			const self_ = this;
			self_.$_slsPrdCrdLyt_start()
		},
		methods: {
			$_slsPrdCrdLyt_start() {
				const self_ = this;
				
				const sales_ = self_.getUserState('sales')
				const merchant_ = self_.$_slsPrdCrdLyt_paramsMerchantId;

				if(self_.isFalse(sales_[merchant_])) {
					sales_[merchant_] = { addedProduct: {}, addedSerialNumber: {} }
				}

				const products_ = self_.$_slsPrdCrdLyt_salesProducts;

				Object.keys(products_).forEach(key => {
					sales_[merchant_].addedProduct[key] = {}
					sales_[merchant_].addedProduct[key].code = key;
					sales_[merchant_].addedProduct[key].title = products_[key].title;
					sales_[merchant_].addedProduct[key].subTitle = products_[key].subTitle;
					sales_[merchant_].addedProduct[key].text = products_[key].text;
					sales_[merchant_].addedProduct[key].image = products_[key].image;
					sales_[merchant_].addedProduct[key].price = products_[key].price;
					sales_[merchant_].addedProduct[key].amount = 0;

					if(!self_.isFalse(products_[key].serialNumbers)) {
						sales_[merchant_].addedProduct[key].serialNumbers = products_[key].serialNumbers;
					}
				})

				self_.setUserState('sales', sales_)
			},
			$_slsPrdCrdLyt_openInput() {
				const self_ = this;

				let link_ = {
					to: {
						name: 'salesInput',
						params: {
							merchantId: self_.$_slsPrdCrdLyt_paramsMerchantId
						}
					}
				}
				
				self_.openLink(link_)
			},
			$_slsPrdCrdLyt_toggleEnterSerialNumber(productKey) {
				const self_ = this;

				if(self_.isObject(self_.serialNumbers_[productKey])) { 
					self_.serialNumber_.key = productKey;
					self_.dialogEnterSerialNumber_ = !self_.dialogEnterSerialNumber_;
					return 
				}

				const merchant_ = self_.$_slsPrdCrdLyt_paramsMerchantId;

				Promise.resolve().then(() => {
					return self_.getSalesByMerchantIdAndProductId(merchant_, productKey)
				}).then(result => {
					self_.serialNumbers_[productKey] = result;
					self_.serialNumber_.key = productKey;
					self_.dialogEnterSerialNumber_ = !self_.dialogEnterSerialNumber_;
				})
			},
			$_slsPrdCrdLyt_enterSerialNumber() {
				const self_ = this;

				const key_ = self_.serialNumber_.key;
				const number_ = self_.serialNumber_.number;

				if(self_.isFalse(self_.serialNumbers_[key_][number_])) { 
					self_.errorMessageEnterSerialNumber_ = 'Wrong Serial Number';
					return 
				}

				const opened_ = self_.serialNumbers_[key_][number_].status.opened;
				const used_ = self_.serialNumbers_[key_][number_].status.used;

				if(self_.isFalse(opened_) || !self_.isFalse(used_)) { 
					self_.errorMessageEnterSerialNumber_ = 'Serial Number Not Available';
					return 
				}

				const today_ = new Date()
				const start_ = self_.convertTimestampToDate(self_.serialNumbers_[key_][number_].startDate)
				const end_ = self_.convertTimestampToDate(self_.serialNumbers_[key_][number_].endDate)

				if(start_ > today_ || end_ < today_) {
					self_.errorMessageEnterSerialNumber_ = 'Serial Number Out Of Date';
					return 
				}

				const sales_ = self_.getUserState('sales')
				const merchant_ = self_.$_slsPrdCrdLyt_paramsMerchantId;

				const products_ = self_.$_slsPrdCrdLyt_salesProducts;

				sales_[merchant_].addedSerialNumber[number_] = {}
				sales_[merchant_].addedSerialNumber[number_].productId = key_;
				sales_[merchant_].addedSerialNumber[number_].serialNumber = number_;
				sales_[merchant_].addedSerialNumber[number_].title = products_[key_].title;
				sales_[merchant_].addedSerialNumber[number_].subTitle = products_[key_].subTitle;
				sales_[merchant_].addedSerialNumber[number_].text = products_[key_].text;
				sales_[merchant_].addedSerialNumber[number_].image = products_[key_].image;
				sales_[merchant_].addedSerialNumber[number_].price = products_[key_].price;

				sales_[merchant_].addedProduct[key_].amount++;

				self_.setUserState('sales', sales_)

				self_.serialNumber_ = { key: null, number: null }

				self_.dialogEnterSerialNumber_ = !self_.dialogEnterSerialNumber_;
			},
			$_slsPrdCrdLyt_addProduct(productKey) {
				const self_ = this;
				
				const sales_ = self_.getUserState('sales')
				const merchant_ = self_.$_slsPrdCrdLyt_paramsMerchantId;

				sales_[merchant_].addedProduct[productKey].amount++;

				self_.setUserState('sales', sales_)
			},
			$_slsPrdCrdLyt_reduceProduct(productKey) {
				const self_ = this;
				
				const sales_ = self_.getUserState('sales')
				const merchant_ = self_.$_slsPrdCrdLyt_paramsMerchantId;

				sales_[merchant_].addedProduct[productKey].amount--;

				self_.setUserState('sales', sales_)
			},
			$_slsPrdCrdLyt_checkAmount(productKey) {
				const self_ = this;
				
				const sales_ = self_.getUserState('sales')
				const merchant_ = self_.$_slsPrdCrdLyt_paramsMerchantId;

				return sales_[merchant_].addedProduct[productKey].amount > 0
			},
			$_slsPrdCrdLyt_getChanceColor(key) {
				const self_ = this;

				if(self_.colors_[key]) { return self_.colors_[key] }

				self_.colors_[key] = self_.getChanceColor()
				return self_.colors_[key]
			}
		}
	}
</script>

<style scoped>
	.row_ {
		height: 48px;
	}
	.btn_ {
		bottom: 24px;
	}
</style>
